import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetFamilyEventDetailsOfSmsPath =
  operations['AdminEventController_getEventResponseSms']['parameters']['path'];
type GetFamilyEventDetailsOfSmsQuery =
  operations['AdminEventController_getEventResponseSms']['parameters']['query'];
type GetFamilyEventDetailsOfSmsHeaders =
  operations['AdminEventController_getEventResponseSms']['parameters']['header'];

interface GetFamilyEventDetailsOfSmsProps {
  path: GetFamilyEventDetailsOfSmsPath;
  query: GetFamilyEventDetailsOfSmsQuery;
  headers?: OmitGroupIdInHeader<GetFamilyEventDetailsOfSmsHeaders>;
}

type GetFamilyEventDetailsOfSmsResponse =
  components['schemas']['List$EventResponse$mZFLkyvTelC5g8XnyQrpOw'];

export async function getFamilyEventDetailsOfSms({
  path,
  headers,
  query,
}: GetFamilyEventDetailsOfSmsProps): Promise<GetFamilyEventDetailsOfSmsResponse | false> {
  const response = await authenticateRequest<GetFamilyEventDetailsOfSmsResponse>({
    method: 'get',
    url: `/api/v1/admin/events/${path.eventId}/details/sms`,
    headers,
    params: query,
  });

  console.log('getFamilyEventDetailsOfSms', { response });
  return response;
}

export type {
  GetFamilyEventDetailsOfSmsPath,
  GetFamilyEventDetailsOfSmsResponse,
  GetFamilyEventDetailsOfSmsQuery,
};
